import styled from "styled-components"
import MuiRadioGroup from "@material-ui/core/RadioGroup"

export const StyledRadioGroup = styled(MuiRadioGroup)`
  flex-direction: ${(props) => props.direction};
`
